module.exports = __webpack_public_path__ + "static/is-2-ede7ad076ee22930531ddb3bd98902e6.png";